import React, { useCallback, useContext, useMemo, useState } from 'react';
import { ScreenableFieldSetupContext } from '../helpers/useScreenableFieldSetupContextManager';
import { InternalApiEntityGroup } from '../../../api-internal';
import { useQuerySegments } from '../../configure/segments/segmentActions';
import { SegmentsTable } from './SegmentsTable';
import InternalLink from '../../../common/InternalLink';
import { SalvSwitch } from '@salvapp/ui-components';

export const IncludedSegmentsStep = () => {
  const { entityType, includedSegments, excludedSegments, updateIncludedSegments } =
    useContext(ScreenableFieldSetupContext);
  const { data: segments, isLoading: isLoading } = useQuerySegments({ entityType });

  const selectedSegments = useMemo(() => {
    return segments?.filter((segment) => segment.code && includedSegments?.includes(segment.code)) ?? [];
  }, [segments, includedSegments]);

  const setSelectedSegments = useCallback(
    (segments: InternalApiEntityGroup[]) => {
      setAllSegmentsEnabled(false);
      updateIncludedSegments(segments.map((it) => it.code!));
    },
    [updateIncludedSegments]
  );

  const [allSegmentsEnabled, setAllSegmentsEnabled] = useState(!includedSegments?.length);

  return (
    <div className='p-a-24'>
      <div>
        <h4 className='text-strong-m chapter-title'>Segments</h4>
        <span className='text-s chapter-subtitle'>
          Choose specific Segments to be used in this Screening Flow, or toggle All Entities to screen all entities.
          Included Segments are combined using AND logic: an entity must be part of all selected Segments to be included
          in the Screening Flow. If you haven’t defined any Segments yet, you can do so{' '}
          <InternalLink title={'here'} link={'/segments'} />.
        </span>
        <SalvSwitch
          label={'All Entities'}
          className={'m-t-16'}
          selected={allSegmentsEnabled}
          onChange={(isToggled) => {
            if (isToggled) {
              updateIncludedSegments([]);
              setAllSegmentsEnabled(true);
            } else {
              updateIncludedSegments(undefined);
              setAllSegmentsEnabled(false);
            }
          }}
        />
        <SegmentsTable
          segments={segments ?? []}
          isLoading={isLoading}
          selectedSegments={selectedSegments}
          setSelectedSegments={setSelectedSegments}
          disabledCodes={excludedSegments ?? []}
        />
      </div>
    </div>
  );
};
